module.exports = __webpack_public_path__ + "img/set-1.ae235586.jpg";